export default __webpack_public_path__ + "static/media/image.fonix-software-solutions-pvt-ltd.0d407d1c.png";